import React from 'react';
import { useMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectLastVisitedDashboardId } from '@/features/dashboards/dashboardsSlice';
import { DASHBOARDS } from '@/util/enums/views.constants';
import { TrevorIcon } from '@trevor/ui-components';
import { DASHBOARD_URL_PATH } from '@/routing/paths';
import { NavigationItem } from './NavigationItem';

export const DashboardsNavigationItem = ({ disabled = false }) => {
  const onDashboardPage = !!useMatch(DASHBOARD_URL_PATH);
  const lastVisitedDashboardId = useSelector(selectLastVisitedDashboardId);

  const url =
    !onDashboardPage && lastVisitedDashboardId
      ? `dashboards/${lastVisitedDashboardId}`
      : null;

  return (
    <NavigationItem
      tab={DASHBOARDS}
      url={url}
      disabled={disabled}
      tooltipText={
        disabled ? 'Save your first query to unlock dashboards' : 'Dashboards'
      }
    >
      <TrevorIcon name="bar-chart" size="md" />
    </NavigationItem>
  );
};
